import {
	Box,
	Divider,
	ListItem,
	ListItemText,
	Typography
} from '@mui/material';
import React, { FC } from 'react';

interface IProps {
	title: string;
	text: string;
}

const ProjectNotificationListItem: FC<IProps> = ({ text, title }) => (
	<>
		<ListItem sx={{ pr: 2 }}>
			<ListItemText sx={{ py: 0 }} data-testid="project-limit-content">
				<Box>
					<Typography variant="body1" color="error">
						{intl.tr(title)}
					</Typography>
					<Typography variant="body1" color="text.secondary">
						{intl.tr(text)}
					</Typography>
				</Box>
			</ListItemText>
		</ListItem>
		<Divider />
	</>
);

export default ProjectNotificationListItem;
